import VuexStoreFactory from "@/_util/vuex-store-factory"

export default {

    template : {
        name : "Fenceline Name",
        description : "Fenceline Description",
        namespace : "core",
        version : "0.1.1",
        icon : "mdi-home",
        accentColor : "red",
        parentRoute : "/fenceline",
        defaultRoute : "",
        // routerDefinition : "routes/index.js",
        navigation : [],
        settings : {},
    },

    buildDefaultRoute : function(appConfig)
    {
        return  {
            path: appConfig.parentRoute,
            name: appConfig.name,
            redirect: `${appConfig.parentRoute}/${appConfig.defaultRoute}`,
            component: appConfig.component,
            children: appConfig.childRoutes
        };
    },

    buildStore : function(appConfig)
    {
        if(!!appConfig.store)
        {
            let vuexStoreFactory = new VuexStoreFactory();
            var vuexModule = vuexStoreFactory.generateVuexNamespacedModule(appConfig.store, appConfig.namespace);
            return vuexModule;
        }
        return null;
    },

    merge : function(config)
    {//Applies an attribute priority. Custom settings from the environment file take priority

        var env = window.$env || {};
        var settings = Object.assign(this.template.settings, config.settings);
        if(env.namespaces && env.namespaces[config.namespace])
        {
            settings = Object.assign(settings, env.namespaces[config.namespace]);
        }
        var ret = Object.assign({}, this.template, config, { settings });

        ret.route = this.buildDefaultRoute(ret);
        ret.storeModule = this.buildStore(ret);

        this.validate(ret);

        return ret;
    },

    validate : function(config)
    {
        if(!config.namespace){//check required value
            throw `Namespace is blank.`;
        }

        {//check namespace pattern;
            var namespaceTestPattern = /[a-zA-Z0-9]/g;
            if(!namespaceTestPattern.test(config.namespace))
            {
                throw `[${config.name}]: Namespaces can only have alpha numeric characters A-Z, a-z or 0-9. (${config.namespace})`;
            }
        }
        {//WARN : old schema router
            if(!!config.routerDefinition)
            {
                console.warn(`[${config.name}]: [config].routerDefinition is no longer used.`);
            }
        }
        {//ERROR : old schema router
            if(!config.childRoutes)
            {
                throw `[${config.name}]: Ensure that you are implementing your child routes in the [config].childRoutes attribute.`;
            }
        }
        {//WARN : old schema storeDefinitions
            if(!!config.storeDefinitions)
            {
                console.warn(`[${config.name}]: [config].storeDefinitions is no longer used.`);
            }
        }
        { //ERROR : check for default route
            if (!config.defaultRoute) {
                throw (`[${config.name}]: [config].defaultRoute should specify your default view.`);
            }
        }
        { //ERROR : check for component
            if (!config.component) {
                throw (`[${config.name}]: [config].component should specify your default master / parent.`);
            }
        }
        
    }
}